/* eslint-disable no-restricted-syntax -- Legacy. */

import { baseGlobals } from '@root/typescript/baseGlobals'

/**
 * Időzítő/késleltető Promise-os függvényünk.
 * @param time - Hány ms után legyen resolve.
 */
export function wait (time: number): Promise<void> {
  return new Promise((resolve) => {
    if (baseGlobals.isTest) {
      resolve()
    }
    else {
      // eslint-disable-next-line no-restricted-globals -- Backend/frontend környezetben miatt ez kell ide.
      setTimeout(resolve, time)
    }
  })
}
